import React, {
  createContext,
  useContext,
  useMemo,
  useReducer,
  useState, // useEffect,
} from 'react';

import { appConfig } from '../../config/app';
import { CustomEvents } from '../../constants/analytics.constant';
import useLogEventInAnalytics from '../../hooks/useLogAnalyticsEvent';
import { useTipification } from '../../hooks/useTipification';
import {
  changePassword as password,
  updateProfile as update,
} from '../../services/users/editProdile.service';
import EditProfileReducer, {
  FAILURE_CHANGE_PASSWORD,
  FAILURE_UPDATE_PROFILE,
  REQUEST_CHANGE_PASSWORD,
  REQUEST_UPDATE_PROFILE,
  SUCCESS_CHANGE_PASSWORD,
  SUCCESS_UPDATE_PROFILE,
} from './editProfile.reducer';

export const EditProfileDataContext = createContext<any>(null);

const initialEditProfileData = {
  submitErrors: {},
  submitSuccess: {},
};

const EditProfileDataProvider = ({ ...props }) => {
  const [state, dispatch] = useReducer(
    EditProfileReducer,
    initialEditProfileData
  );
  const [loading, setLoading] = useState(false);
  const { logEvent } = useLogEventInAnalytics();
  const { trackEvent, events } = useTipification();

  const updateProfile = async (body: any) => {
    setLoading(true);
    dispatch({
      type: REQUEST_UPDATE_PROFILE,
    });
    try {
      trackEvent(events.USER_ENDORSMENT_CHANGE_MAIL);
      trackEvent(events.USER_ENDORSMENT_CHANGE_PHONE);
      if (body.emergency_phone)
        trackEvent(events.USER_ENDORSMENT_CHANGE_PHONE_ADDITIONAL);
      const res = await update({
        user: {
          ...body,
          phone: body.phone_number,
        },
      });
      await logEvent(CustomEvents.PROFILE_UPDATE, {
        app: appConfig?.NAME,
      });
      dispatch({
        type: SUCCESS_UPDATE_PROFILE,
        payload: res.data,
      });
      setLoading(false);
    } catch (err) {
      dispatch({
        type: FAILURE_UPDATE_PROFILE,
        payload: err.response.data,
      });
      setLoading(false);
    }
  };

  const changePassword = async (body: any) => {
    setLoading(true);
    dispatch({
      type: REQUEST_CHANGE_PASSWORD,
    });
    try {
      trackEvent(events.USER_ENDORSMENT_CHANGE_PASSWORD);
      const res = await password({
        user: {
          ...body,
        },
      });
      dispatch({
        type: SUCCESS_CHANGE_PASSWORD,
        payload: res.data,
      });
      setLoading(false);
    } catch (err) {
      dispatch({
        type: FAILURE_CHANGE_PASSWORD,
        payload: err.response.data,
      });
      setLoading(false);
    }
  };

  const EditProfileDataValue = useMemo(
    () => ({ ...state, loading, updateProfile, changePassword }),
    [state, loading, updateProfile, changePassword]
  );

  return (
    <EditProfileDataContext.Provider value={EditProfileDataValue} {...props} />
  );
};

export const useEditProfileDataContext = () =>
  useContext(EditProfileDataContext);

export default EditProfileDataProvider;
